// @ts-nocheck
import { useDisconnect, useAppKitAccount  } from '@reown/appkit/react'
import { type BaseError, useWriteContract, useWaitForTransactionReceipt, useReadContract } from 'wagmi'
import { abi, tokenabi } from '../data/NFTcontract.json'
import { useEffect, useState } from 'react'
import { formatEther } from 'viem'

export const Connected = () => {
  const { disconnect } = useDisconnect(); // AppKit hook to disconnect
  const { isConnected } = useAppKitAccount() // AppKit hook to get the address and check if the user is connected

  const handleDisconnect = async () => {
    try {
      await disconnect();
    } catch (error) {
      console.error("Failed to disconnect:", error);
    }
  };

  const maxValue = BigInt(2) ** BigInt(256) - BigInt(1);  // 2^256 - 1
  const tolerance = 2;

  const { data: totalSupplyData, refetch: getSupply } = useReadContract({
    address: import.meta.env.VITE_CONTRACT_ADDRESS,
    abi: abi,
    functionName: "totalSupply",
  });

  const {data: mintPriceData, refetch: getPrice} = useReadContract({
    abi,
    address: import.meta.env.VITE_CONTRACT_ADDRESS,
    functionName: 'cost',
  });

  useEffect(() => {
    const interval = setInterval(() => {
      getSaleStart();
      getSupply(); 
      getPrice();
      getChangePrice();
      getChangeTokenPrice();
    }, 5000);// Ruft die Werte alle 5 Sekunden ab

    return () => clearInterval(interval); // Cleanup der Intervalle beim Unmounten
  }, [getSupply, getPrice]);

  const {data: maxMintAmountData} = useReadContract({
    abi,
    address: import.meta.env.VITE_CONTRACT_ADDRESS,
    functionName: 'maxMintAmount',
  });

  const {data: maxSupplyData} = useReadContract({
    abi,
    address: import.meta.env.VITE_CONTRACT_ADDRESS,
    functionName: 'MAX_SUPPLY',
  });

  const {
    data: hash,
    error,
    isPending,
    writeContract
  } = useWriteContract()

  async function mint() {
    await writeContract({
      value: BigInt(mintPriceData) * BigInt(mintAmount) * (BigInt(100) + BigInt(tolerance)) / BigInt(100),
      address: import.meta.env.VITE_CONTRACT_ADDRESS,
      abi,
      functionName: 'mint',
      args: [mintAmount]
    })
  }

  const { data: useWaitForTransactionReceiptData, isLoading: isConfirming, isSuccess: isConfirmed } =
    useWaitForTransactionReceipt({
      hash,
    })

  useEffect(() => {
    console.log("mintPrice:", hash);
    console.log("mintPrice:", useWaitForTransactionReceiptData);
  }, [hash, useWaitForTransactionReceiptData]);

  const [mintAmount, setMintAmount] = useState(1);

  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > BigInt(maxMintAmountData) || 
    BigInt(totalSupplyData) + BigInt(newMintAmount) >
    BigInt(maxSupplyData)) {
      newMintAmount = mintAmount;
    }
    setMintAmount(newMintAmount);
  };

  const { data: saleStartData, refetch: getSaleStart } = useReadContract({
    address: import.meta.env.VITE_CONTRACT_ADDRESS,
    abi: abi,
    functionName: "saleStart",
  });

  const [timestamp, setTimestamp] = useState(Math.floor(new Date().getTime() / 1000));

  useEffect(() => {
    const interval = setInterval(() => {
      setTimestamp(Math.floor(new Date().getTime() / 1000)); // Umwandlung in Unix-Timestamp (Sekunden)
    }, 1000); // Aktualisierung jede Sekunde

    return () => clearInterval(interval); // Aufräumen bei Unmount
  }, []);

  return (
    isConnected && (
      <div className={"connected"}>
        {
          timestamp <= saleStartData &&
          <div className="pages">
            <div className={"description"}>
              <p>Launch at 2:00PM on Thursday, May 8, 2025 (EDT)</p>
            </div>
            <p>
              <button onClick={handleDisconnect}>Disconnect</button>
            </p> 
          </div>           
          ||
            BigInt(maxSupplyData) - BigInt(totalSupplyData) != 0 &&
            <div className="pages">
              <h1 className={"supply"}>{String(totalSupplyData)}  /{' '}{String(maxSupplyData)} SHIB<span className="red-text">Pupz</span></h1>
              <p className={"price"}>Total Price {formatEther(BigInt(mintAmount) * BigInt(mintPriceData) * (BigInt(100) + BigInt(tolerance)) / BigInt(100))} ETH</p>
              <p className={"price"}>
                <button disabled={isPending || isConfirming ? true : false} onClick={decrementMintAmount}>-</button>
                {mintAmount}
                <button disabled={isPending || isConfirming ? true : false} onClick={incrementMintAmount}>+</button>
                Mint Amount
              </p>
              <p>
                <button onClick={handleDisconnect}>Disconnect</button>
                <button disabled={isPending || isConfirming ? true : false} onClick={mint}>{isPending || isConfirming ? 'Confirming...' : 'Mint NFTs'}</button>
              </p> 
              {!isConfirming && !isConfirmed && <div className={"status"}><br/></div>}
              {isConfirming && <div className={"status"}>Waiting for confirmation...</div>}
              {isConfirmed && <div className={"status"}>Transaction confirmed.</div>}
              {!error && !hash &&<div className={"hash"}><br/></div>}
              {hash && <div className={"hash"}>Transaction Hash: {hash}</div>}
              {error && ( 
                <div>Error: {(error as BaseError).shortMessage || error.message }</div>
              )}
              <div className={"grid"}>
                <div className={"card"}>
                  <h2>Live Price</h2>
                  <p>{formatEther(BigInt(mintPriceData) * (BigInt(100) + BigInt(tolerance)) / BigInt(100))} ETH ≈ $55</p>
                  <p>plus a {tolerance}% tolerance, with unused funds refunded automatically.</p>
                </div>
              </div>
            </div> ||
              <div className="pages">
                <div className={"description"}>
                  We are minted out!
                </div>
              <p>
                <button onClick={handleDisconnect}>Disconnect</button>
              </p> 
            </div>
          }
        <div className={"grid"}>
          <div className={"card2"}>
            <h2>Allocation of funds</h2>
            <p>$255 will be used to update DEXTools for increased exposure. $850 will be used to purchase our tokens, which will be used for NFT holder airdrops. The remaining $5,000 will be used to pay CoinMarketCap.</p>
          </div>
      </div>
      </div>
    )
  )
}
